import { Directive, HostListener, Input } from '@angular/core';
import { FlyoutService } from './flyout.service';

@Directive({
  selector: '[aeFlyout]'
})
export class FlyoutDirective {
// tslint:disable-next-line:no-input-rename
@Input('id') public id: string;

  constructor(private flyoutService: FlyoutService) { }


  @HostListener('click', ['$event'])
  getFlyout() {
    this.flyoutService.toggleFlyout(this.id);
    }
  }
